/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/

import * as actions from ".";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { User, LoadStatus } from "../../../types";

export interface UseWithUsers {
  users: Record<string, User>;
  userLoadStatus: LoadStatus;
  loadAllUsers: () => Promise<User[]>;
  updateUser: (newData: User) => Promise<User>;
}

export default function useWithUsers(): UseWithUsers {
  const { users, userLoadStatus } = useAppSelector((state) => state.users);
  const dispatch = useAppDispatch();

  async function loadAllUsers(): Promise<User[]> {
    if (userLoadStatus === LoadStatus.IN_PROGRESS) return [];
    return await dispatch(actions.loadUsers()).unwrap();
  }

  async function updateUser(data: User): Promise<User> {
    return await dispatch(actions.updateUser(data)).unwrap();
  }

  return {
    users,
    userLoadStatus,
    loadAllUsers,
    updateUser,
  };
}
